export const formatPrice = (price?: number | null): string => {
  if (price === undefined || price === null) return "";

  return `${new Intl.NumberFormat("ru-Ru", {}).format(price)}`;
};
